import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const highlightBNPLBasketSelector = createSelector(testTargetOffersSelector, offers => offers.highlightBNPLBasket || Empty.Object);

export { highlightBNPLBasketSelector };
